import { IconTypes } from './Icons'

export default function SendBold({
  fontSize = '1.6rem',
  rotate = 0,
  className = '',
}: Omit<IconTypes, 'color'>) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      style={{
        width: '1em',
        height: '1em',
        fontSize,
        transform: `rotate(${rotate}deg)`,
      }}
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M21.2071 12.0404C21.2143 11.4814 20.9115 10.9676 20.4197 10.6979L8.96008 4.40166C8.4468 4.11156 7.84173 4.1472 7.35807 4.47747C6.86554 4.8133 6.61344 5.61276 6.75112 6.19016L7.82093 10.6723C7.93076 11.1319 8.3421 11.4555 8.81533 11.4535L15.1926 11.4337C15.5192 11.4271 15.784 11.692 15.7775 12.0185C15.7765 12.3396 15.5155 12.6005 15.189 12.6071L8.80562 12.6219C8.33239 12.6228 7.91904 12.9479 7.80636 13.4082L6.69872 17.9081C6.56423 18.4398 6.71756 18.9707 7.09276 19.3459C7.1369 19.39 7.18656 19.4397 7.23626 19.4783C7.72216 19.8532 8.35851 19.901 8.90182 19.6115L20.4004 13.3768C20.8938 13.1152 21.1998 12.5995 21.2071 12.0404Z'
        fill='url(#paint0_linear_1089_15509)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1089_15509'
          x1='9.94424'
          y1='0.13564'
          x2='19.89'
          y2='13.4395'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#fff' />
          <stop offset='1' stopColor='#ffff' />
        </linearGradient>
      </defs>
    </svg>
  )
}
